import { React, Link, $, NavLink } from "../../../Headers";
// import './FooterInsideWrapper.css';
export default class AppSidebar extends React.Component {
  render() {
    return (
      <>
        <aside
          id="ss-uad-sidebar-01"
          className="main-sidebar sidebar-dark-primary elevation-4"
        >
          <Link id="ss-uad-sidebar-02" class="brand-link">
            <div id="ss-uad-sidebar-03">
              <img
                id="ss-uad-sidebar-04"
                src={"../../uploads/logo-right-text.png"}
              />
            </div>
          </Link>

          {/* <!-- Sidebar --> */}
          <div class="sidebar" id="sidebar">
            {/* <!-- SidebarSearch Form --> */}
            <div style={{ marginTop: "5px" }}></div>
            <div class="form-inline"></div>

            {/* <!-- Sidebar Menu --> */}
            <nav class="mt-2">
              <ul
                class="nav nav-pills nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                {/* <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library --> */}
                <li class="nav-item">
                  <NavLink
                    to="/user_dashboard"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="nav-icon fas fa-tachometer-alt"></i>
                    <p>
                      Dashboard
                      {/* <span class="right badge badge-danger">New</span> */}
                    </p>
                  </NavLink>
                </li>

                <li class="nav-item">
                  <NavLink
                    to="/manuscript/admin"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="nav-icon fas fa-exclamation-triangle"></i>
                    <p>Manuscript</p>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    to="/create_web_book"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="fas fa-book nav-icon"></i>
                    <p>Create Book</p>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    to="/create_book_carousel"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="fas fa-book nav-icon"></i>
                    <p>Create Book Carousel</p>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    to="/web_book_contact"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="fas fa-book nav-icon"></i>
                    <p>Book Contact info</p>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    to="/web_book_orders"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="fas fa-shopping-cart nav-icon"></i>
                    <p>Book Orders</p>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    to="/create_journals"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="fas fa-book nav-icon"></i>
                    <p>Create Journal</p>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    to="/journals_details"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="fas fa-book nav-icon"></i>
                    <p>Add Journal Details</p>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    to="/admin/subs"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="nav-icon fas fa-bell"></i>
                    <p>Subscription</p>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    to="/author_form_details"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="fas fa-book nav-icon"></i>
                    <p>Author Form</p>
                  </NavLink>
                </li>
                {/* <li class="user_dashboard">
                  <NavLink to="/" className="nav-link" activeClassName="active1">
                    <i class="nav-icon fa fa-sign-out-alt"></i>
                    <p>
                    Go Live
                    </p>
                  </NavLink>
                </li> */}
                {/* <li class="nav-item">
                  <NavLink to="/user_dashboard" className="nav-link" activeClassName="active1">
                    <i class="nav-icon fa fa-sign-out-alt"></i>
                    <p>
                      MIS
                    </p>
                  </NavLink>
                </li> */}
                <li class="nav-item">
                  <NavLink
                    to="/logout"
                    className="nav-link"
                    activeClassName="active1"
                  >
                    <i class="nav-icon fa fa-sign-out-alt"></i>
                    <p>Log Out</p>
                  </NavLink>
                </li>
              </ul>
            </nav>
            {/* <!-- /.sidebar-menu --> */}
          </div>
          {/* <!-- /.sidebar --> */}
        </aside>
      </>
      //</div>
      //</body>
    );
  }
}
